// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3Mcfc","container":"styles_container__1LZkO","title":"styles_title__urbox","wrapper":"styles_wrapper__2HMUG","answer":"styles_answer__2sJuS"};